var map = {
	"./0.jpeg": 8748,
	"./1.jpeg": 9395,
	"./2.jpeg": 8751,
	"./3.jpeg": 698,
	"./4.jpeg": 9170,
	"./5.jpeg": 8917,
	"./6.jpeg": 6056,
	"./7.jpeg": 7384,
	"./8.jpeg": 4402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1112;